export const FETCH_STATIC_PAGES_ENDPOINT = 'api/static-pages';
export const FETCH_BANNERS_ENDPOINT = 'api/banners';
export const FETCH_CONFIG_ENDPOINT = 'config';
export const FETCH_ARTICLES_ENDPOINT = 'api/articles';
export const CONTACT_ENDPOINT = 'api/contact';



// WEBPACK FOOTER //
// ./src/constants/endpoints.ts